import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { get } from 'lodash';
import { getMessage } from 'util/locale';

// components
import Date from 'planting-plan-form/Date';
import PlantingFertilizerApplication from 'common/PlantingFertilizerApplication';
import SeedProductInputsContainer from 'products/SeedProductInputsContainer';

const baseString = 'vra-manual-planting-plan-form-inputs';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-plan-form-inputs': true
});
const ManualPlantingPlanFormInputs = ({
  isAppMode,
  maxDate,
  minDate,
  onChangePlantingFertilizerApplication,
  onSelectDate,
  plantingPlanParams,
  validationResult
}) => {
  const dateValidations = get(validationResult, 'date');

  return (
    <section className={classString}>
      <section className='vra-planting-plan-form__fieldset vra-planting-plan-form__fieldset--date'>
        <Date
          headerText={getMessage('title-text__planting-date')}
          isAppMode={isAppMode}
          maxDate={maxDate}
          minDate={minDate}
          onSelectDate={onSelectDate}
          selected={plantingPlanParams.date}
          validationResult={dateValidations}
        />
      </section>
      <section className='vra-planting-plan-form__fieldset vra-planting-plan-form__fieldset--seed-products'>
        <SeedProductInputsContainer />
      </section>
      <section className='vra-planting-plan-form__fieldset vra-planting-plan-form__fieldset--planting-fertilizer'>
        <PlantingFertilizerApplication
          hasPlantingFertilizerApplication={plantingPlanParams.hasPlantingFertilizerApplication}
          helpTextKey={'text__planting-fertilizer-application--planting-plan'}
          isFormFieldset={false}
          onChange={onChangePlantingFertilizerApplication}
        />
      </section>
    </section>
  );
};

ManualPlantingPlanFormInputs.propTypes = {
  isAppMode: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onSelectDate: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  validationResult: propTypes.object
};
export default ManualPlantingPlanFormInputs;
